import React from "react";
import PropTypes from "prop-types";
import HighchartsReact from "highcharts-react-official";

const Highcharts = window.Highcharts;

function AcquisionVisitorWebActivity({ chartData, pieData }) {
  const chartDataPaid = chartData.map((data) => data.Paid);
  const chartDataDirect = chartData.map((data) => data.Direct);
  const chartDataOther = chartData.map((data) => data.Other);
  const chartDataOrganic = chartData.map((data) => data.Organic);
  const chartDataReferral = chartData.map((data) => data.Referral);
  const chartDataX = chartData.map((data) => data.day);

  const chartColors = {
    Paid: "#573B7A",
    Organic: "#428BCA",
    Direct: "#74C372",
    Other: "#FFBF00",
    Referral: "#E35D6A",
  };
  const chartDataSummary = pieData.map((data) => ({
    name: data.label,
    y: data.value,
    color: chartColors[data.label],
  }));

  const chartOptions = {
    chart: {
      type: "column",
    },
    legend: {
      enabled: true,
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "Visitor Web Activity",
      style: {
        fontWeight: "bold",
        fontSize: "14",
      },
    },
    subtitle: {
      text: null,
    },
    xAxis: {
      categories: chartDataX,
      crosshair: true,
    },
    yAxis: {
      title: {
        text: null,
      },
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        borderRadius: 5,
      },
    },
    series: [
      {
        color: "#573B7A",
        name: "Paid",
        data: chartDataPaid,
      },
      {
        color: "#428BCA",
        name: "Organic",
        data: chartDataOrganic,
      },
      {
        color: "#74C372",
        name: "Direct",
        data: chartDataDirect,
      },
      {
        color: "#FFBF00",
        name: "Other",
        data: chartDataOther,
      },
      {
        color: "#E35D6A",
        name: "Referral",
        data: chartDataReferral,
      },
      {
        type: "pie",
        name: "Acquisition Summary",
        data: chartDataSummary,
        center: ["2%", "5%"],
        size: 75,
        showInLegend: false,
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.0f}%</b>",
          percentageDecimals: 1,
        },
        dataLabels: {
          enabled: false,
        },
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
}

AcquisionVisitorWebActivity.propTypes = {
  chartData: PropTypes.array.isRequired,
  pieData: PropTypes.array.isRequired,
};

export default AcquisionVisitorWebActivity;
